import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {EBookComponent} from './e-book.component';
import {AddEbookComponent} from './add-ebook/add-ebook.component';

const routes: Routes = [
  {
    path: 'ebooks',
    component: EBookComponent,
    data: {animation: 'e-books'}
  },
  {
    path: 'ebooks/add',
    component: AddEbookComponent,
    data: {animation: 'category/add'}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EBookRoutingModule { }
